// import SetClient from './SetClient'
import SetCategory from './SetCategory'
import SetType from './SetType'
import SetPriority from './SetPriority'
import SetDueDate from './SetDueDate'
import SetOwner from './SetOwner'
import SetLead from './SetLead'
import SetAssignees from './SetAssignees'
import SetWatchers from './SetWatchers'
import SetStatus from './SetStatus'
// import SetTags from './SetTags'
import MarkComplete from './MarkComplete'
// import Close from './Close'
import Favorite from './Favorite'
import Unfavorite from './Unfavorite'
import CopyLink from './CopyLink'
import Share from './Share'

type ButtonDef = {
  key: string
  Comp: React.FC
}

type ButtonDefBlock = ButtonDef[]

const buttons: ButtonDefBlock[] = [
  [
    // {
    //   key: 'set-client',
    //   Comp: SetClient
    // },
    {
      key: 'set-category',
      Comp: SetCategory
    },
    {
      key: 'set-type',
      Comp: SetType
    },
    {
      key: 'set-priority',
      Comp: SetPriority
    },
    {
      key: 'set-due-date',
      Comp: SetDueDate
    }
  ],

  [
    {
      key: 'set-owner',
      Comp: SetOwner
    },
    {
      key: 'set-lead',
      Comp: SetLead
    },
    {
      key: 'set-assignees',
      Comp: SetAssignees
    },
    {
      key: 'set-watchers',
      Comp: SetWatchers
    },
    {
      key: 'set-status',
      Comp: SetStatus
    }
  ],

  // [
  // {
  //   key: 'set-tags',
  //   Comp: SetTags
  // },
  // {
  //   key: 'mark-complete',
  //   Comp: MarkComplete
  // },
  // {
  //   key: 'close',
  //   Comp: Close
  // }
  // ],

  [
    {
      key: 'mark-complete',
      Comp: MarkComplete
    },
    {
      key: 'favorite',
      Comp: Favorite
    },
    {
      key: 'unfavorite',
      Comp: Unfavorite
    },
    {
      key: 'copy-link',
      Comp: CopyLink
    },
    {
      key: 'share',
      Comp: Share
    }
  ]
]

export default buttons
